var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73644 1.50585C7.32568 1.39443 5.27926 2.99489 4.83801 5.13426C4.74459 5.58576 5.13895 5.99999 5.62503 5.99999C6.0082 5.99999 6.32207 5.73732 6.40124 5.38182C6.74324 3.83982 8.34002 2.72937 10.1292 3.05712C11.6508 3.33612 12.7482 4.70001 12.6619 6.16551C12.5938 7.32726 11.8042 8.06388 10.8961 8.91063C10.0641 9.68688 9.14242 10.5459 8.82417 11.8037C8.70226 12.2829 9.07252 12.75 9.59265 12.75C9.97027 12.75 10.2771 12.493 10.3673 12.145C10.5874 11.302 11.255 10.679 12.0063 9.9785C13.0545 9.00125 14.242 7.89403 14.2499 6.01903C14.2586 3.96628 12.8842 2.18687 10.7894 1.66112C10.4338 1.57187 10.0808 1.52176 9.73644 1.50585ZM9.10404 15C8.88554 15 8.7082 15.168 8.7082 15.375V16.125C8.7082 16.332 8.88554 16.5 9.10404 16.5H9.89571C10.1142 16.5 10.2915 16.332 10.2915 16.125V15.375C10.2915 15.168 10.1142 15 9.89571 15H9.10404Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/questionIcon.bb77cb7e5fc3fbdbbe67c6b7795c7096.svg";
export { ForwardRef as ReactComponent };